// extracted by mini-css-extract-plugin
module.exports = {"header-wrapper":"blogView-m__header-wrapper__3Jmw_","list":"blogView-m__list__3E7sW","link-btn":"blogView-m__link-btn__3PGaE"};